import { render, staticRenderFns } from "./ServicePrices.vue?vue&type=template&id=bf4223c0&scoped=true&"
import script from "./ServicePrices.vue?vue&type=script&lang=js&"
export * from "./ServicePrices.vue?vue&type=script&lang=js&"
import style0 from "./ServicePrices.vue?vue&type=style&index=0&id=bf4223c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4223c0",
  null
  
)

export default component.exports